
































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import AdminBrandId from "@/mixins/adminBrandId";
import CountriesStore from "@/mixins/constants/countriesStore";
import { FraudEntities, FraudLevels, FraudTypes } from "@/data/fraud";
import { FraudDetectionTypes, FraudDetectionEntities } from "@/data/enums";
import { ITableConfig } from "@/models/tables";
import { Sorters } from "@/data/table";
import { ConfirmModalModes } from "@/data/enums";
import { FraudDetectionFilters } from "@/data/filters/fraud";
import { FraudDetectionSorters } from "@/data/sorters/fraud";
import { FilterOperators, FilterTypes } from "@/data/table";

@Component
export default class FraudRulesTable extends Mixins(
  FilteringSortingTableStore,
  CountriesStore,
  AdminBrandId
) {
  // Props
  @Prop({ required: true })
  public entity!: string;

  @Prop({ required: true })
  public type!: string;

  public defaults: ITableConfig = {
    sort: {
      field: "level,-created_at",
      direction: Sorters.ASCENDING
    }
  };

  public filters = FraudDetectionFilters;
  public sorters = FraudDetectionSorters;

  public entities = FraudEntities();
  public types = FraudTypes();
  public levels = FraudLevels();

  public loading = true;
  public dataModule: DataModules = DataModules.FRAUD_DETECTION;

  public async created() {
    this.setFilters();
    this.getData();
  }

  // Computed
  public get isForCountry() {
    return this.type === FraudDetectionTypes.COUNTRY;
  }
  public get entityName() {
    return this.$_.get(
      this.$_.find(this.entities, t => t.id === this.entity),
      "label"
    );
  }

  public canUpdate(rule) {
    return rule.entity === "brand"
      ? this.$userCan("update_brand_fraud_check_settings")
      : this.$userCan("update_organisation_fraud_check_settings");
  }

  public canDelete(rule) {
    return rule.entity === "brand"
      ? this.$userCan("delete_brand_fraud_check_settings")
      : this.$userCan("delete_organisation_fraud_check_settings");
  }

  // Methods
  public setFilters() {
    if (this.type !== FraudDetectionTypes.IP) return;
    this.filters = this.$_.concat(this.filters, [
      {
        key: "value",
        label: this.type === FraudDetectionTypes.IP ? "ip" : "country",
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      }
    ]);
  }

  public getValue(rule) {
    if (this.type === FraudDetectionTypes.COUNTRY) {
      return this.$_.get(
        this.$_.find(this.countries, c => c.code === rule.value),
        "name"
      );
    }
    return rule.value;
  }

  public async confirmDelete(rule) {
    if (!this.canDelete(rule)) return;

    const modal = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        parent: this,
        props: {
          mode:
            rule.entity === "brand"
              ? ConfirmModalModes.BUTTON
              : ConfirmModalModes.PIN,
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message:
            rule.entity === "brand"
              ? this.$t("_sentence.delete_confirmation", {
                  object: (this.$t("_.rule") as string).toLowerCase()
                })
              : this.$t("_sentence.delete_org_level_rule")
        },
        canCancel: [],
        events: {
          confirmed: async () => {
            try {
              await this.deleteRule(rule);

              this.$buefy.toast.open({
                message: this.$t("_.object_successfully_removed", {
                  object: this.$t("_.rule")
                }) as string
              });
              modal.close();
            } catch (error) {
              modal.$children[0].stopProcessing();
              this.$store.dispatch("api/handleError", error);
            }
          }
        }
      }
    });
  }

  public deleteRule(rule) {
    const payload = {
      id: rule.id,
      entity: rule.brand_id
        ? FraudDetectionEntities.BRAND
        : FraudDetectionEntities.ORGANISATION,
      type: this.type,
      scope: this.dataScope,
      vm: this
    };
    if (rule.brand_id) {
      payload["data"] = {
        brand_id: this.brandId
      };
    }

    return this.$store
      .dispatch(`data/${DataModules.FRAUD_DETECTION}/delete`, payload)
      .then(() => {
        this.getData({ ignoreStored: true });
      });
  }

  public updateRule(rule) {
    if (!this.canUpdate(rule)) return;

    this.$store.dispatch(
      `data/${DataModules.FRAUD_DETECTION}/openAddEditModal`,
      {
        props: {
          rule
        },
        events: {
          success: () => {
            this.getData({ ignoreStored: true });
          }
        }
      }
    );
  }

  // overrides mixin method
  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(params, {
      entity: this.entity,
      type: this.type
    });
  }
}
